import(/* webpackMode: "eager" */ "/home/runner/work/lifti-partners-frontend/lifti-partners-frontend/src/app/auth/forgotpassword/page.tsx")